import { useContext } from 'react'
import { SidebarContext } from './context'

export function useSidebarProvider() {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error('useSidebarProvider must be used within a SidebarProvider')
  }
  return context
}
